import { graphql } from 'react-relay';

export const contentPageFragment = graphql`
  fragment ContentPage_page on ContentPage {
    breadcrumbs {
      ...Breadcrumb_data
    }
    __typename
    title
    siblingNavigation {
      ...SiblingNavigation_siblingNavigation
    }
    blocks {
      __typename
      ...AwardsListBlock_contentBlock
      ...LocationBlock_contentBlock
      ...AbstractBlock_contentBlock
      ...LogoBlock_contentBlock
      ...MarkdownBlock_contentBlock
      ...PictureBlock_contentBlock
      ...QuoteBlock_contentBlock
      ...TextBlock_contentBlock
    }
  }
`;
